import React from 'react';
import { Box } from '@mui/material';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import SettingsBrightnessOutlinedIcon from '@mui/icons-material/SettingsBrightnessOutlined';
import { NEXT_COLOR_SCHEME, useColorScheme } from '../../contexts/ColorSchemeContext';

const ColorSchemeButton = ({ className, sx, iconSize = 24, variant = 'icon' }) => {
  const { colorScheme, resolvedMode, toggleColorScheme } = useColorScheme();
  const nextScheme = NEXT_COLOR_SCHEME[colorScheme];
  const label = {
    system: '시스템 설정 따르기',
    light: '라이트 모드로 전환',
    dark: '다크 모드로 전환',
  }[nextScheme];
  const ToggleIcon =
    nextScheme === 'system'
      ? SettingsBrightnessOutlinedIcon
      : nextScheme === 'light'
        ? LightModeOutlinedIcon
        : DarkModeOutlinedIcon;
  const isSwitch = variant === 'switch';
  const buttonClassName = [
    className,
    isSwitch ? 'color-scheme-switch' : '',
    isSwitch && resolvedMode === 'dark' ? 'is-dark' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Box
      component="button"
      className={buttonClassName}
      onClick={toggleColorScheme}
      sx={sx}
      title={label}
      aria-label={label}
    >
      {isSwitch ? (
        <span className="color-scheme-switch-track" aria-hidden="true">
          <span className="color-scheme-switch-thumb" />
          <span className="color-scheme-switch-icon color-scheme-switch-icon-sun">
            <LightModeOutlinedIcon sx={{ fontSize: 16 }} />
          </span>
          <span className="color-scheme-switch-icon color-scheme-switch-icon-moon">
            <DarkModeOutlinedIcon sx={{ fontSize: 16 }} />
          </span>
        </span>
      ) : (
        <ToggleIcon sx={{ fontSize: iconSize }} />
      )}
    </Box>
  );
};

export default ColorSchemeButton;
